import e from "react";
import { translate as r } from "@aws-amplify/ui";
import { Flex as o } from "../../../primitives/Flex/Flex.js";
import { Heading as n } from "../../../primitives/Heading/Heading.js";
import { useAuthenticator as t } from "@aws-amplify/ui-react-core";
import { useCustomComponents as i } from "../hooks/useCustomComponents/index.js";
import { useFormHandlers as m } from "../hooks/useFormHandlers/useFormHandlers.js";
import { FormFields as a } from "../shared/FormFields.js";
import { ConfirmSignInFooter as l } from "../shared/ConfirmSignInFooter.js";
import { RemoteErrorMessage as s } from "../shared/RemoteErrorMessage.js";
import { RouteContainer as c } from "../RouteContainer/RouteContainer.js";
const d = _ref => {
  let {
    className: r,
    variation: n
  } = _ref;
  const {
      isPending: f
    } = t(e => [e.isPending]),
    {
      handleChange: u,
      handleSubmit: p
    } = m(),
    {
      components: {
        ConfirmSignIn: {
          Header: h = d.Header,
          Footer: E = d.Footer
        }
      }
    } = i();
  return e.createElement(c, {
    className: r,
    variation: n
  }, e.createElement("form", {
    "data-amplify-form": "",
    "data-amplify-authenticator-confirmsignin": "",
    method: "post",
    onChange: u,
    onSubmit: p
  }, e.createElement(o, {
    as: "fieldset",
    direction: "column",
    isDisabled: f
  }, e.createElement(h, null), e.createElement(o, {
    direction: "column"
  }, e.createElement(a, null), e.createElement(s, null)), e.createElement(l, null), e.createElement(E, null))));
};
d.Header = function () {
  const {
      user: o
    } = t(),
    {
      challengeName: i
    } = o;
  let m;
  switch (i) {
    case "SMS_MFA":
      m = r("Confirm SMS Code");
      break;
    case "SOFTWARE_TOKEN_MFA":
      m = r("Confirm TOTP Code");
      break;
    default:
      throw new Error("".concat(r("Unexpected challengeName encountered in ConfirmSignIn:"), " ").concat(i));
  }
  return e.createElement(n, {
    level: 3
  }, m);
}, d.Footer = function () {
  return null;
};
export { d as ConfirmSignIn };